import { render } from "./RickstroSection.vue?vue&type=template&id=238b031b&scoped=true"
import script from "./RickstroSection.vue?vue&type=script&lang=js"
export * from "./RickstroSection.vue?vue&type=script&lang=js"

import "./RickstroSection.vue?vue&type=style&index=0&id=238b031b&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238b031b"]])

export default __exports__